import { fromJS } from 'immutable';
import { LOAD_TASK_SCHEDULE_SUCCESS, DELETE_TASK_SCHEDULE_SUCCESS } from 'constants/ActionTypes';

const initialState = fromJS({
  pagination: {},
  dataset: [],
});

/**
 * Reducer for TaskTemplateTable component
 * @param state
 * @param action
 * @returns {any}
 */
const taskScheduleTableReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_TASK_SCHEDULE_SUCCESS: {
      return state.set('dataset', fromJS(action.schedules.items.map((schedule) => schedule.scheduleId))).set(
        'pagination',
        fromJS({
          totalCount: action.schedules._meta.totalCount,
          pageCount: action.schedules._meta.pageCount,
          currentPage: action.schedules._meta.currentPage,
          perPage: action.schedules._meta.perPage,
        }),
      );
    }
    case DELETE_TASK_SCHEDULE_SUCCESS:
      return state.set(
        'dataset',
        state.get('dataset').filter((scheduleId) => scheduleId !== action.entityId),
      );
    default:
      return state;
  }
};

export default taskScheduleTableReducer;
